import React from 'react';
import { Flex, Card, Image, Rate, Tag } from 'antd';
import { QrcodeOutlined, ShareAltOutlined, LinkOutlined, ShoppingOutlined, CopyOutlined, MinusCircleOutlined } from '@ant-design/icons';
// import CardContent from './card-content';
import { getCurrentShopId } from '../shop/get-current-shop';
import { openWxminiGoods } from './tools';
import { openWxminiShop } from '../shop/tools';

export default ({content = {}, onProxyClick, onProxyCancel}) => {
    const accId = window.__baseInfo.accId;
    const [currentShopId, setCurrentShopId] = React.useState(null);

    React.useEffect(() => {
        const fetchCurrentShopId = async () => {
            const shopId = await getCurrentShopId();
            setCurrentShopId(shopId);
        };
        
        fetchCurrentShopId();
    }, []);

    const {
        goodsId, cateId, accId: goodsAccId,
        type, title, status, minNum, realSaleNum, offlineSaleNum, inventory, shortDescription, sysCateId,
        properties, price, marketPrice, prepaidAmount, createTime, uuid, unit, mainImages,
        goods_partner_level_percents, 
        shopId_shops,               // 代理关系数据
        rating = {}
    } = content;
    const [isOpen, setIsOpen] = React.useState(false);

    // 获取代理佣金
    const profit = goods_partner_level_percents && goods_partner_level_percents[0] ? goods_partner_level_percents[0].percent : 0;
    
    // 构造商品展示数据
    const areas = [];
    const fromShops = [];
    const fromShopId = shopId_shops?.[0]?.goods_shop?.fromShopId;   // 获取商品来源店铺ID，与我有代理关系的情况下才该字段。
    // console.log('fromShopId', fromShopId);
    shopId_shops?.forEach(item => {
        if(item.shop_biz_address) {
            // 当在我的代理商品关系中时，则只显示代理店铺所在城市或省份
            if(fromShopId) {
                if(item.shop_biz_address.city && item.shopId === fromShopId) areas.push(item.shop_biz_address.city);
                else if(item.shop_biz_address.province && item.shopId === fromShopId) areas.push(item.shop_biz_address.province);
            }else{
                if(item.shop_biz_address.city) areas.push(item.shop_biz_address.city);
                else if(item.shop_biz_address.province) areas.push(item.shop_biz_address.province);
            }
        }

        fromShops.push({title: item.title, shopId: item.shopId});
    });

    if(areas.length === 0) {
        areas.push('未知');
    }

    const onWxGoodsUrlClick = async () => {
        if (!currentShopId) return;
        await openWxminiGoods(accId, currentShopId, goodsId);
    }

    const onWxShopUrlClick = async (shopId) => {
        if (!currentShopId) return;
        await openWxminiShop(accId, shopId);
    }

    const CardHeader = props => {
        return (
            <Flex justify="space-between">
                <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{title}</div>
                <Flex gap={10}>
                    {/* <div><ShareAltOutlined /></div>
                    <div><QrcodeOutlined /></div> */}
                    <a onClick={onWxGoodsUrlClick}><LinkOutlined /></a>
                </Flex>
            </Flex>
        )
    }

    const actions = [<div><ShoppingOutlined key="edit" /> 商品详情</div>,];

    // 与自己有代理关系
    if(fromShopId) {
        actions.push(
            <div onClick={() => onProxyCancel?.(content)}><MinusCircleOutlined key="cancel" /> 取消代理</div>,
        );
    }
    // 该商品不属于自己
    else if(currentShopId && !shopId_shops?.find(item => item.shopId === currentShopId)) {
        actions.push(
            <div onClick={() => onProxyClick?.(content)}><ShoppingOutlined key="edit" /> 一键代理</div>,
        );
    }

    return (
        <Card title={<CardHeader />} style={{minWidth: 360, maxWidth: 456, width: '100%'}}
            actions={actions}
        >
            <Flex justify="" align="left" gap={10} style={{fontSize: 12}}>
                <Image
                    width={80}
                    height={80}
                    style={{minWidth: '80px'}}
                    src={`//img.yxdj.tech/${mainImages[0]}?x-oss-process=image/resize,w_200`}
                />
                <div>
                    <span>价格：{price/100}元/{unit} <del>{marketPrice/100}元</del> 销量：{realSaleNum}</span>
                    <div>服务评分：{rating.score ? <Rate allowHalf defaultValue={rating.score} /> : '暂无评分'} </div>
                    <div>代理佣金：{profit}%</div>
                    <div>服务区域：{ areas.map((c, i) => (<Tag key={i}>{c}</Tag>))}</div>
                    <div>服务来自：{ fromShops.map((c, i) => (<a style={{marginRight: 10}} onClick={() => onWxShopUrlClick(c.shopId)} key={i}>{c.title}</a>))}</div>
                </div>
            </Flex>
        </Card>
    )
}